
import { type NavigationTypeType, type SsrData, defaultNavigationIndex, moveByOptions } from "@quickpoint.me/shared";
import type { ReactElement } from "react";
import { atom, selector } from "recoil";
import type { ElementProps } from "../functionalComponents/RenderPage";
import { PageIndex, RenderedPageElementsToDisplay } from "./page";
import { NumberOfPages } from "./selectors";
import { TapDirection } from "./ui";
declare const window: {
    __SSR_DATA: SsrData | undefined;
} & Window;


// in scroll top index is current pageIndex and bottom is current pageIndex+1
// in tap left index is current pageIndex-1  and right is current pageIndex


export const BottomElements = selector<ReactElement<ElementProps>[]>({
    key: "VS_BottomIndexElements",
    get: ({ get }) => {
        const index = get(BottomPageIndex)
        return RenderedPageElementsToDisplay(index)
    }
})

// pageIndex is base 1.
export const BottomPageIndex = selector<number>({
    key: "VS_BottomPageIndex",
    get: ({ get }) => {
        const bottomPageIndex = get(PageIndex) + 1
        const numberOfPages = get(NumberOfPages)
        if (bottomPageIndex > numberOfPages) return numberOfPages
        return bottomPageIndex;
    }
});


export const TopElements = selector<ReactElement<ElementProps>[]>({
    key: "VS_TopElements",
    get: ({ get }) => {
        const index = get(TopPageIndex)
        return RenderedPageElementsToDisplay(index)
    }
})


const navigationType = window.__SSR_DATA?.navigationType ? window.__SSR_DATA.navigationType : moveByOptions[defaultNavigationIndex] as NavigationTypeType

export const NavigationType = atom<NavigationTypeType>({
    key: "VS_NavigationType",
    //@ts-expect-error
    default: navigationType
})

// pageIndex is base 1.
export const TopPageIndex = selector<number>({
    key: "VS_TopPageIndex",
    get: ({ get }) => {
        return get(PageIndex)
    }
});


export const RightElements = selector<ReactElement<ElementProps>[]>({
    key: "VS_RightIndexElements",
    get: ({ get }) => {
        const index = get(RightPageIndex)
        return RenderedPageElementsToDisplay(index)
    }
})

// pageIndex is base 1.
export const RightPageIndex = selector<number>({
    key: "VS_RightPageIndex",
    get: ({ get }) => {
        const rightPageIndex = get(PageIndex)
        const numberOfPages = get(NumberOfPages)
        const direction = get(TapDirection)
        const dirIdx = direction === "forward" || direction === "init" ? 0 : 1
        const idx = rightPageIndex + dirIdx
        if (idx > numberOfPages) return numberOfPages
        return idx
    }
});


export const LeftElements = selector<ReactElement<ElementProps>[]>({
    key: "VS_LeftElements",
    get: ({ get }) => {
        const index = get(LeftPageIndex)
        return RenderedPageElementsToDisplay(index)
    }
})


// pageIndex is base 1.
export const LeftPageIndex = selector<number>({
    key: "VS_LeftPageIndex",
    get: ({ get }) => {
        const direction = get(TapDirection)
        const dirIdx = direction === "forward" || direction === "init" ? -1 : 0
        const index = get(PageIndex) + dirIdx
        if (index < 1) return 1
        return index
    }
});

